import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  emailLabel: {
    id: 'contactPerson.props.email.label',
    description: 'Label for contact person property email',
    defaultMessage: 'Email',
  },
  firstNameLabel: {
    id: 'contactPerson.props.firstName.label',
    description: 'Label for contact person property first name',
    defaultMessage: 'First name',
  },
  lastNameLabel: {
    id: 'contactPerson.props.lastName.label',
    description: 'Label for contact person property last name',
    defaultMessage: 'Last name',
  },
  phoneLabel: {
    id: 'contactPerson.props.phone.label',
    description: 'Label for contact person property phone',
    defaultMessage: 'Phone',
  }
});
